module.exports = __webpack_public_path__ + "img/pic-immersive-reading.85d8e5f.webp";